import translations from '../translations.json';
import { getCookie } from './getCookie';

export const languageCookie = "com.elementn.common.sessionLocale";
export const language = getCookie(languageCookie) === "ar" ? "ar" : "en";

export const getTranslatedMessage = msg => {
	return translations[msg][language]
}



// WEBPACK FOOTER //
// ./src/utils/translations.js